export const FIND_TABLE_ENTRIES_SUCCESS = 'FIND_TABLE_ENTRIES_SUCCESS';

export const findTableEntriesSuccess = ({ tableEntries }) => ({
    type: FIND_TABLE_ENTRIES_SUCCESS,
    payload: {
        tableEntries,
    },
});
